// ©2024 Austin App House. All rights reserved.
import React from 'react';

const FiltersModalShell = ({
  title,
  onClose,
  footer,
  children,
}) => (
  <div
    className="dashboard-modal dashboard-modal--open dashboard-modal--filters"
    role="presentation"
    onClick={onClose}
  >
    <div
      className="dashboard-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="wo-filters-title"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="dashboard-modal-header">
        <div className="dashboard-modal-title" id="wo-filters-title">{title}</div>
        <button
          type="button"
          className="dashboard-modal-close"
          aria-label="Close filters"
          onClick={onClose}
        />
      </div>
      <div className="dashboard-modal-body wurqly-modal-scroll dashboard-modal-form-scroll">
        {children}
      </div>
      {footer ? (
        <div className="dashboard-modal-footer">
          {footer}
        </div>
      ) : null}
    </div>
  </div>
);

export default FiltersModalShell;
